import { ValuableModel } from '../../models/ValuableModel'

export class SchemaIterableModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.Iterable': SchemaIterableModel
  }
}
